import React from 'react'
import { Row, Col, Typography } from 'antd'

const { Paragraph } = Typography

class Copyright extends React.Component {
    render() {
        return (
            <Row>
                <Col>
                    <Paragraph>
                        Copyright © 2021 中国农业科学院深圳农业基因组研究所.
                    </Paragraph>
                </Col>
            </Row>
        )
    }
}

export default Copyright